/* Dashboard intro animation — once per app load (Tushar, 2-Nov-2026).
   The dashboard's charts animate in the FIRST time the dashboard appears after
   RockLink opens (or is reloaded); coming back from a stage page, Stores,
   Analyst… shows them still. Module-level, so a full reload re-arms it. */
let played = false;

export function dashboardIntroPending() {
  return !played;
}

export function markDashboardIntroPlayed() {
  played = true;
}
